<template>
    <div class="card-container agentmanage">
        <common-top-form :model="formModel" @openAddDialog="addInfo" :submitService="submitService" buttonName="导出" @reset="reset" :needReset="true" buttonType="warning"
                         addShowPower="/statis/exportByTat" :submitData="submitData" @success="onSuccess" :showDownloadPower="false" :show="false"
                         showDownloadPowerType="purple" downloadPowerText="合计" downloadPower="/statis/getAllTatCount" @down="down">
                <select-organs v-model="formModel.tatSimpleId" :selectValue="formModel.tatSimpleId"></select-organs>

            <el-form-item label="交易类型">
                <el-select v-model="formModel.tranType" filterable multiple >
                    <el-option
                        v-for="item in tranTypes"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="业务类型">
                <el-select v-model="formModel.acctType" multiple >
                    <el-option
                        v-for="item in acctTypes"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                    </el-option>
                </el-select>
            </el-form-item>
                <el-form-item label="收益日期">
                    <el-date-picker
                        v-model="formModel.time"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        align="right"
                        unlink-panels
                        :clearable="false"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column type="index" width="80" label="序号"></el-table-column>
            <el-table-column prop="tatName" label="机构简称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tranAmt" label="收益金额(元)" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.tranAmt * 100 / 10000)}}</p>
                </template>
            </el-table-column>
        </common-table>
        <show-info-dialog title="合计" :show="true" ref="showInfoDialog" dialogWidth="400px" class="showInfoDialog">
            <div>
                <p>交易总笔数：{{dialogObj.totalTran}}笔</p>
                <p>交易成功总笔数：{{dialogObj.succTran}}笔</p>
                <p>交易总金额：{{toDoubleThousands(dialogObj.totalAmt)}}元</p>
            </div>
        </show-info-dialog>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import SelectOrgans from 'components/business/SelectOrgans'
    import ShowInfoDialog from '../../dialog/ShowInfoDialog'
    import OrganService from 'service/OrganService'
    import StatisticsService from 'service/StatisticsService'
    import privateKey from 'service/constant/privateKey'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin,dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'
    import TimeRange from 'service/constant/TimeRange'
    export default {
        name: "organprofitstatistics",
        data() {
            return {
                formModel:{
                    tatSimpleId:'',
                    tranType:[],
                    acctType:[],
                    time: TimeRange.monthRange,
                },
                tableData:[],
                tranTypes: [],
                acctTypes: [],
                dialogObj:{},
                submitService:StatisticsService.countMdbFinTatacctDtl,
                page:{},
                status:'',
                showMsg:'',
                isPage:false,
                all: [{
                    id: '',
                    simpleName: '全部'
                }],
                allDic: [{
                    dictKey: '',
                    dictValue: '全部'
                }],
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                }
            }
        },
        mixins:[loadMixin,dialogMixin],
        components: {
            CommonTopForm ,
            CommonTable,
            ShowInfoDialog,
            SelectOrgans,
        },
        mounted(){
            this.page = this.$refs.commonTable.page;

            this.getTypeNames('交易类型', (res) => {
                this.tranTypes = [{
                    dictKey: '',
                    dictValue: '全部'
                }, ...res];
            })
            this.getTypeNames('业务类型', (res) => {
                this.acctTypes = [{
                    dictKey: '',
                    dictValue: '全部'
                }, ...res]
            });
            this.getList();
        },
        computed: {
            submitData() {
                const params = {
                    tatSimpleId: this.formModel.tatSimpleId,
                    tranType: this.formModel.tranType.join(','),
                    acctTypes: this.formModel.acctType.join(','),
                    startDate : this.formModel.time[0],
                    endDate : this.formModel.time[1],
                    userId: this.userId,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                return params;
            },
            ...mapGetters(['serverType','tatId','userId'])
        },
        methods: {
            getPage(){
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService,this.submitData,res => {
                    this.doCheck(res,res =>{
                        this.onSuccess(res)
                        this.isPage = false;
                    });
                },'信息获取失败')
            },
            onSuccess(data) {
                this.doCheck(data,res => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                })
            },
            reset(){
                this.formModel = {
                    tatSimpleId:'',
                    tranType:[],
                    acctType:[],
                    time: TimeRange.monthRange,
                };
                this.getList();
            },
            addInfo() {
                StatisticsService.exportExcel(this.submitData, 'exportByTat')
            },
            down(){
                this.doLoad(StatisticsService.getAllTatCount,this.submitData,res => {
                    this.doCheck(res,res =>{
                        const result = res.contents;
                        this.dialogObj = result;
                        this.$nextTick(()=>{
                            this.$refs.showInfoDialog.open();
                        })
                    });
                },'信息获取失败')
            }
        }
    }
</script>

<style scoped>
    .detail-box p{
        font-size: 14px;
        color: #000;
        line-height: 2;
    }
    .detail-box p span{
        font-weight: 700;
        display: inline-block;
        width: 6em;
        letter-spacing: 0.13em;
        margin-right: -0.13em;
    }
    .detail-box p span.three{
        letter-spacing: 0.5em;
        margin-right: -0.5em;
    }

    .showInfoDialog p{
        font-size: 16px;
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/StatisticsManage/OrganProfitStatistics.vue